<template>
  <div class="mian_c">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
          </div>
          <div
            style="font-size: 0.35rem; margin-left: -0.2rem"
          >
            贷款计算器
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div class="tab_con">
      <span :class="tab === 1 ? 'active' : ''" @click="changeTab(1)"
        >商业贷款</span
      >
      <span :class="tab === 2 ? 'active' : ''" @click="changeTab(2)"
        >组合贷款</span
      >
      <span :class="tab === 3 ? 'active' : ''" @click="changeTab(3)"
        >公积金贷款</span
      >
    </div>
    <div class="intermediate">
      <div class="row_f">
        <van-row>
          <van-col span="8">
            <span>计算方式</span>
          </van-col>
          <van-col span="16">
            <van-radio-group v-model="radio" direction="horizontal">
              <van-radio name="1" shape="square">按贷款总额</van-radio>
              <van-radio name="2" shape="square">按房屋总价</van-radio>
            </van-radio-group>
          </van-col>
        </van-row>
      </div>
      <!-- 按房屋总价 -->
      <div>
        <van-field
          v-show="radio == 2"
          v-model="houseTotal"
          label="房屋总价"
          placeholder="请输入商贷金额"
        >
          <template #button>
            <div class="b_pad">万</div>
          </template>
        </van-field>
        <van-field
          v-show="radio == 2"
          v-model="loanScale"
          label="贷款比例"
          placeholder="请输入贷款比例"
        >
          <template #button>
            <div class="b_pad">成</div>
          </template>
        </van-field>
        <van-field
          v-show="tab == 2"
          v-model="loanTotal"
          label="贷款总额"
          placeholder="请输入贷款总额"
        >
          <template #button>
            <div class="b_pad">万</div>
          </template>
        </van-field>
      </div>
      <!-- 公积金 -->
      <div
        :class="tab == 2 ? 'accumulation' : ''"
        v-show="tab == 2 || tab == 3"
      >
        <van-field
          v-model="accumulationPrice"
          label="公积金金额"
          placeholder="请输入公积金金额"
        >
          <template #button>
            <div class="b_pad">万</div>
          </template>
        </van-field>
        <van-field
          v-model="value1"
          label="公积金年限"
          placeholder="请选择公积金年限"
          readonly
          clickable
          @click="yearsPicker = true"
        />
        <van-popup v-model="yearsPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="yearsList"
            @confirm="yearsConfirm"
            @cancel="yearsPicker = false"
          />
          <div style="padding: 0 20%">
            <van-field v-model="value5" label="自定义倍数" placeholder="请输入">
              <template #button>
                <div class="b_pad">倍</div>
              </template>
            </van-field>
          </div>
        </van-popup>
        <van-field
          v-model="value1"
          label="公积金利率"
          placeholder="请选择公积金利率"
          readonly
          clickable
          @click="yearsPicker = true"
        />
        <van-popup v-model="yearsPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="yearsList"
            @confirm="yearsConfirm"
            @cancel="yearsPicker = false"
          />
          <div style="padding: 0 20%">
            <van-field v-model="value5" label="自定义倍数" placeholder="请输入">
              <template #button>
                <div class="b_pad">倍</div>
              </template>
            </van-field>
          </div>
        </van-popup>
      </div>
      <!-- 商贷 -->
      <div class="commercial">
        <van-field
          v-show="tab == 1 || tab == 2"
          v-model="value"
          label="商贷金额"
          placeholder="请输入商贷金额"
        >
          <template #button>
            <div class="b_pad">万</div>
          </template>
        </van-field>
        <van-field
          v-show="tab == 1 || tab == 2"
          v-model="value1"
          label="商贷年限"
          placeholder="请选择商贷年限"
          readonly
          clickable
          @click="yearsPicker = true"
        />
        <van-popup v-model="yearsPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="yearsList"
            @confirm="yearsConfirm"
            @cancel="yearsPicker = false"
          />
        </van-popup>
        <van-field
          v-show="tab == 1 || tab == 2"
          v-model="value2"
          label="利率方式"
          placeholder="请选择利率方式"
          readonly
          clickable
          @click="ratePicker = true"
        />
        <van-popup v-model="ratePicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="rateList"
            @confirm="rateConfirm"
            @cancel="ratePicker = false"
          />
        </van-popup>
      </div>
      <div class="row_t" v-show="tab == 1 || tab == 2">
        <p>7月20日</p>
        <div>LPR：一年期3.85%，五年期4.65%</div>
        <p @click="show_two = true">历史LPR</p>
      </div>
      <div>
        <van-field
          v-show="tab == 1 || tab == 2"
          left-icon="warning-o"
          @click-left-icon.stop="show = true"
          v-model="value3"
          label="商贷利率"
          placeholder="请选择商贷利率"
          readonly
          clickable
          @click="loanPicker = true"
        />
        <van-popup v-model="loanPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="loanList"
            @confirm="loanConfirm"
            @cancel="loanPicker = false"
          />
          <div style="padding: 0 20%">
            <van-field v-model="value5" label="自定义利率" placeholder="请输入">
              <template #button>
                <div>%</div>
              </template>
            </van-field>
          </div>
        </van-popup>
      </div>

      <div class="btn">
        <p>开始计算</p>
      </div>
      <van-overlay :show="show">
        <div class="wrapper" @click.stop>
          <div class="wra_block">
            <div class="block_tit">商贷利率</div>
            <div>
              自2019年10月8日起,商业贷款利率的计算方式由"贷款基准利率(4.9%)*上浮或下浮比例"改为"LPR+基点"
              <br />
              <br />
              基点,即浮动值,10基点=0.1% <br />
              <br />
              提醒：如果是存量贷款的固定利率转LPR，则基点=（老利率-4.8%）x 10000
              <br />
              <br />
              举例当前贷款利率4.9%，下浮10%，则：老利率为4.9%*（1-10%）=4.41%基点=（4.41%-4.8%）*10000=
              -39
            </div>

            <div class="block_btn">
              <p @click="show = false">我知道了</p>
            </div>
          </div>
        </div>
      </van-overlay>
      <van-overlay :show="show_two">
        <div class="wrapper" @click.stop>
          <div class="wra_block">
            <div class="block_tit">LPR(贷款市场报价利率)</div>
            <div>
              自2019年10月8日起，新发放的商业住房贷款的贷款利率由“贷款基准利率（4.9%）”转换为“贷款市场报价利率（LPR）”。在LPR的基础上增加基点来确定最终的商贷利率；
              <br />
              <br />
              LPR每月20日（遇节假日顺延）报价一次，可在中国银行网站查询。<br />
              <br />
              <h5>最近一年LPR值</h5>
              <br />
              （贷款年限在1-5年期间，由银行自主选择采用一年期or五年期LPR）
              <br />
              <br />
            </div>
            <div>
              <table align="center" width="100%">
                <thead style="background: #cfcfcf">
                  <tr>
                    <th width="40%">发布时间</th>
                    <th width="30%">一年期</th>
                    <th width="30%">五年期</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th width="40%">2121</th>
                    <th width="30%">21212</th>
                    <th width="30%">2121212</th>
                  </tr>
                  <tr>
                    <th width="40%">212121</th>
                    <th width="30%">212121212</th>
                    <th width="30%">2121212</th>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="block_btn">
              <p @click="show_two = false">我知道了</p>
            </div>
          </div>
        </div>
      </van-overlay>
    </div>
  </div>
</template>
<script>
import appHeader from "@/components/appHeader";
export default {
  data() {
    return {
      show_two: false,
      show: false,
      houseTotal: "",
      loanTotal: "",
      loanScale: "",
      loanPicker: false,
      ratePicker: false,
      yearsPicker: false,
      tab: 1,
      radio: "1",
      yearsList: [
        "1年",
        "2年",
        "3年",
        "4年",
        "5年",
        "6年",
        "7年",
        "8年",
        "9年",
        "10年",
        "11年",
        "12年",
        "13年",
        "14年",
        "15年",
        "16年",
        "17年",
        "18年",
        "19年",
        "20年",
        "21年",
        "22年",
        "23年",
        "24年",
        "25年",
        "26年",
        "27年",
        "28年",
        "29年",
        "30年",
      ],
      rateList: ["按旧版基准利率", "按LRP"],
    };
  },
  components: {
    appHeader,
  },
  methods: {
    goback() {},
    yearsConfirm(value) {},
    changeTab(type) {
      this.tab = type;
      // if (type == 0) {
      //   this.definition = "人才";
      // }
      // if (type == 1) {
      //   this.definition = "刚需";
      // }
      // if (type == 2) {
      //   this.definition = "普通";
      // }
    },
  },
};
</script>
 <style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.top_header {
  height: 0.5rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.btn {
  margin-top: 1rem;
  padding: 0 2rem;
  p {
    border-radius: 5px;
    text-align: center;
    padding: 10px 0;
    background: #007fff;
    color: #fff;
  }
}
.row_t {
  text-align: center;
  margin: 0.6rem 0;
  background: #ccffff;
  display: flex;
  padding: 20px 10px;
  justify-content: center;
  align-items: center;
  p {
    padding: 0.1rem 0;
    color: #fff;
    border-radius: 5px;
    background: #007fff;
    flex: 2;
  }
  div {
    flex: 7;
  }
}
.wra_block {
  border-radius: 5px;
  width: 4.5rem;
  // height: 8rem;
  color: #000;
  background: #fff;
  padding: 0.2rem 0.3rem;
  .block_tit {
    padding: 0.2rem 0;
    font-size: 0.3rem;
    font-weight: 900;
  }
  .block_btn {
    margin-top: 0.3rem;
    // padding: 0 1.5rem;
    p {
      padding: 0.1rem 0;
      background: #007fff;
      border-radius: 5px;
      text-align: center;
      color: #fff;
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  table {
    width: 100%;
    border-collapse: collapse;
    border: none;
    td,
    th {
      border:1px solid #000 ;
    }
  }
}
.mian_c {
  padding: 0 0.1rem;
}
.intermediate {
  // padding: 0 0.3rem;
  .row_f {
    padding: 10px 16px;
    border-bottom: 1px solid #e5e5e5;
  }
  .accumulation {
    border-top: 10px solid #e5e5e5;
    border-bottom: 10px solid #e5e5e5;
  }
  .b_pad {
    padding-right: 0.5rem;
  }
}
.tab_con {
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e5e5e5;
  display: flex;
  height: 1rem;
  background-color: #fff;
  z-index: 9;
  span {
    text-align: center;
    flex: 1;
    font-weight: 800;
    font-size: 0.3rem;
    margin: 0.3rem;
    position: relative;
  }
  .active {
    color: #3072f5;
    font-size: 0.3rem;
    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      transform: translateX(-50%);
      background-color: #3072f5;
      width: 1.1rem;
      height: 0.04rem;
    }
  }
}
</style>